import axios from 'axios'
import { Toast } from 'vant'

const http = axios.create({
  baseURL: 'https://fwmapp.lopal.cn/prod-api/',
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '
    // 'Authorization': 'Bearer ' + localStorage.getItem('scanH5Token')
  },

})

// 添加请求拦截器
http.interceptors.request.use(
  function (config) {
    // if (localStorage.getItem('scanH5Token')) {
    //   config.headers.set('Authorization', 'Bearer ' + localStorage.getItem('scanH5Token'))
    // }
    
    // console.warn('入参' + JSON.stringify(config))
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
http.interceptors.response.use(
  function (response) {
    // console.warn('返回参:' + JSON.stringify(response))
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.data.code != 200) {
      Toast.fail(response.data.msg)
    }
    return response.data
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // console.warn(JSON.stringify(error))
    return Promise.reject(error)
  }
)

export default http